/**
 * The Form 7004 reads (PG-11): ordinary catalog GETs; every write is a named exception in
 * `form-7004-writes.ts`. Split out of `catalog.ts` on file-size grounds only.
 *
 * The list sits AT the prefix itself (one segment shorter than `/:orderId`, so the two cannot
 * collide) and takes one filter, `status`. The detail answers the facts, the signed form and proof
 * links (15 minutes) and where the form goes. `prepare`, `send`, `mailed` and `cancel` sit BELOW the
 * id and are POST-only upstream, so nothing deeper is declared and none is reachable as a GET;
 * `upstream-siblings.ts` records the prefix as surveyed with no static sibling beside the id.
 */
import type { ReadRoute } from "./catalog";

export const FORM_7004_READ_ROUTES: readonly ReadRoute[] = [
  { path: "/api/admin/form-7004", query: ["status"] },
  { path: "/api/admin/form-7004/:orderId", query: [] },
];
